<p-card [style]="{ width: '75vw' }">
  <p-table [value]="catalogWorkflowNotifications" dataKey="id" editMode="row" class="table-sm" [tableStyle]="{ 'width': '100%' }">
    <ng-template #header>
      <tr>
        <th colspan="2">Notifications</th>
        <th>Active</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template #body let-notification let-editing="editing" let-rowIndex="rowIndex">
      <tr>
        <td>
          <div class="flex w-full">{{ notification.workflowStatusCode.orderEntityType }}</div>
        </td>
        <td>
          <div class="flex w-full">{{ notification.workflowStatusCode.name }}</div>
        </td>
        <td>
          <p-toggleswitch
            [(ngModel)]="notification.isActive"
            attr.data-testid="toggle{{ notification.id }}"
            (change)="updateCatalogWorkflowNotification(notification)" />
        </td>
        <td>
          <button
            pButton
            pRipple
            type="button"
            icon="fa fa-pencil"
            text
            rounded
            severity="secondary"
            (click)="dlgEdit(notification)"
            [outlined]="true"
            attr.data-testid="dlgEdit{{ notification.id }}"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-card>

<ng-container *ngIf="this.dlgVars.notification">
  <p-dialog
    [modal]="true"
    [showHeader]="false"
    [position]="'center'"
    [closeOnEscape]="false"
    [closable]="false"
    [(visible)]="dlgVars.visible"
    [style]="{ 'width': '50vw' }"
    appendTo="body">
    <ng-template pTemplate="header">
      Notification for
      <strong>{{ dlgVars.notification.workflowStatusCode.orderEntityType }} {{ dlgVars.notification.workflowStatusCode.name }}</strong>
    </ng-template>
    <div *ngIf="!dlgVars.hdrEditorVisible && !dlgVars.bdyEditorVisible && !dlgVars.ftrEditorVisible" class="mt-2 w-full">
      <div class="grid mt-2 mb-2 w-full">
        <div class="col-11">
          <app-address-book labelText="To" [(addressList)]="dlgVars.notification.toList"></app-address-book>
          <div style="font-size: 0.75rem; font-style: italic; color: gray">
            <span>NOTE: The 'To' list includes Requester automatically</span>
          </div>
        </div>
      </div>
      <div class="grid mb-4 w-full">
        <div class="col-11">
          <app-address-book labelText="CC" [(addressList)]="dlgVars.notification.ccList"></app-address-book>
          <div style="font-size: 0.75rem; font-style: italic; color: gray">
            <span>NOTE: The 'CC' list includes Delegates automatically</span>
          </div>
        </div>
      </div>
      <div class="grid mb-2 w-full">
        <div class="col-11">
          <p-floatlabel variant="on" class="w-full">
            <label for="subject">Subject</label>
            <input
              pInputText
              id="subject"
              [(ngModel)]="dlgVars.notification.subjectTemplate"
              class="w-full"
              autocomplete="off"
              data-testid="notificationSubject" />
          </p-floatlabel>
        </div>
      </div>
      <div class="mb-2 w-full">
        <label style="font-size: small; font-weight: normal; margin-left: 0.5rem">Body Header</label>
        <div class="grid">
          <div class="col-11 align-items-top">
            <p-editor
              id="hdrViewer"
              [ngModel]="this.dlgVars.notification.bodyHeaderText"
              [style]="{ height: '5rem', width: '100%' }"
              [styleClass]="'w-full'"
              [readonly]="true"
              data-testid="hdrViewer">
              <ng-template #header></ng-template>
            </p-editor>
          </div>
          <div class="col-1 align-items-top justify-content-end">
            <button
              pButton
              pRipple
              type="button"
              icon="fa fa-pencil"
              text
              rounded
              severity="secondary"
              [outlined]="true"
              (click)="hdrEditorShow()"
              data-testid="hdrEditorShow"></button>
          </div>
        </div>
      </div>
      <div class="mb-2 w-full">
        <label style="font-size: small; font-weight: normal; margin-left: 0.5rem">Body Content</label>
        <div class="grid">
          <div class="col-11 align-items-top">
            <p-editor
              id="bdyViewer"
              [ngModel]="this.dlgVars.notification.bodyTemplate"
              [style]="{ height: '10rem', width: '100%' }"
              [styleClass]="'w-full'"
              [readonly]="true"
              data-testid="bdyViewer">
              <ng-template #header></ng-template>
            </p-editor>
          </div>
          <div class="col-1 align-items-top justify-content-end">
            <button
              pButton
              pRipple
              type="button"
              icon="fa fa-pencil"
              text
              rounded
              severity="secondary"
              [outlined]="true"
              (click)="bdyEditorShow()"
              data-testid="bdyEditorShow"></button>
          </div>
        </div>
      </div>
      <div class="mb-2 w-full">
        <label style="font-size: small; font-weight: normal; margin-left: 0.5rem">Body Footer</label>
        <div class="grid">
          <div class="col-11 align-items-top">
            <p-editor
              id="ftrViewer"
              [ngModel]="this.dlgVars.notification.bodyFooterText"
              [style]="{ height: '5rem', width: '100%' }"
              [styleClass]="'w-full'"
              [readonly]="true"
              data-testid="ftrViewer">
              <ng-template #header></ng-template>
            </p-editor>
          </div>
          <div class="col-1 align-items-top justify-content-end">
            <button
              pButton
              pRipple
              type="button"
              icon="fa fa-pencil"
              text
              rounded
              severity="secondary"
              [outlined]="true"
              (click)="ftrEditorShow()"
              data-testid="ftrEditorShow"></button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="dlgVars.hdrEditorVisible" class="mt-2 w-full">
      <label style="font-size: small; font-weight: normal; margin-left: 0.5rem">Body Header</label>
      <div class="grid">
        <div class="col-11">
          <p-editor id="hdrEditor" [(ngModel)]="this.dlgVars.hdrEditorValue" [style]="{ height: '30rem', width: '100%' }" data-testid="hdrEditor">
          </p-editor>
        </div>
        <div class="col-1">
          <button
            pButton
            pRipple
            type="button"
            icon="fa fa-check"
            text
            rounded
            severity="success"
            [outlined]="true"
            (click)="hdrEditorDone()"
            data-testid="hdrEditorDone"></button>
          <button
            pButton
            pRipple
            type="button"
            icon="fa fa-times"
            text
            rounded
            severity="danger"
            [outlined]="true"
            (click)="hdrEditorCancel()"
            data-testid="hdrEditorCancel"></button>
        </div>
      </div>
    </div>
    <div *ngIf="dlgVars.bdyEditorVisible" class="mt-2 w-full">
      <label style="font-size: small; font-weight: normal; margin-left: 0.5rem">Body Content</label>
      <div class="grid">
        <div class="col-11">
          <p-editor id="bdyEditor" [(ngModel)]="this.dlgVars.bdyEditorValue" [style]="{ height: '30rem', width: '100%' }" data-testid="bdyEditor">
          </p-editor>
        </div>
        <div class="col-1">
          <button
            pButton
            pRipple
            type="button"
            icon="fa fa-check"
            text
            rounded
            severity="success"
            [outlined]="true"
            (click)="bdyEditorDone()"
            data-testid="bdyEditorSave"></button>
          <button
            pButton
            pRipple
            type="button"
            icon="fa fa-times"
            text
            rounded
            severity="danger"
            [outlined]="true"
            (click)="bdyEditorCancel()"
            data-testid="bdyEditorCancel"></button>
        </div>
      </div>
    </div>
    <div *ngIf="dlgVars.ftrEditorVisible" class="mt-2 w-full">
      <label style="font-size: small; font-weight: normal; margin-left: 0.5rem">Body Footer</label>
      <div class="grid">
        <div class="col-11">
          <p-editor id="ftrEditor" [(ngModel)]="this.dlgVars.ftrEditorValue" [style]="{ height: '30rem', width: '100%' }" data-testid="ftrEditor">
          </p-editor>
        </div>
        <div class="col-1">
          <button
            pButton
            pRipple
            type="button"
            icon="fa fa-check"
            text
            rounded
            severity="success"
            [outlined]="true"
            (click)="ftrEditorDone()"
            data-testid="ftrEditorSave"></button>
          <button
            pButton
            pRipple
            type="button"
            icon="fa fa-times"
            text
            rounded
            severity="danger"
            [outlined]="true"
            (click)="ftrEditorCancel()"
            data-testid="ftrEditorCancel"></button>
        </div>
      </div>
    </div>
    <ng-template pTemplate="footer" class="flex justify-content-between gap-2 mt-2">
      <ng-container *ngIf="!this.dlgVars.hdrEditorVisible && !this.dlgVars.bdyEditorVisible && !this.dlgVars.ftrEditorVisible">
        <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
          <p-button
            label="Cancel"
            icon="fa fa-times"
            severity="danger"
            size="small"
            [raised]="true"
            (click)="dlgCancel()"
            data-testid="newItemCancel" />
          <p-button
            label="Save"
            icon="fa fa-check"
            severity="success"
            size="small"
            [raised]="true"
            (click)="dlgSave()"
            [disabled]="!isNotificationsDialogValid"
            data-testid="newItemSave" />
        </div>
      </ng-container>
    </ng-template>
  </p-dialog>
</ng-container>
